import { render, staticRenderFns } from "./menu-techs-own.vue?vue&type=template&id=57798c24&scoped=true&lang=pug"
import script from "./menu-techs-own.vue?vue&type=script&lang=ts"
export * from "./menu-techs-own.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57798c24",
  null
  
)

export default component.exports